import type { JSX, ReactNode } from 'react';

interface StepProps {
  /** Step number */
  number: number;
  /** Step title */
  title: string;
  /** Step description */
  description?: string;
  /** Step children (takes priority over description) */
  children?: ReactNode;
}

export const Step = ({ number, title, description, children }: StepProps): JSX.Element => {
  return (
    <div className='step'>
      <div className='step-number'>{number}</div>
      <h3 className='step-title'>{title}</h3>
      <div className='step-description'>{children ?? description}</div>
    </div>
  );
};
